function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import __ from 'ramda/src/__';
import findIndex from 'ramda/src/findIndex';
import pathOr from 'ramda/src/pathOr';
import moment from 'moment';
import clone from 'ramda/src/clone';
import i18n from 'invision-core/src/components/i18n/i18n';
import { CODES } from 'invision-core/src/components/metadata/codes/codes.constants';
import { fetchCodeTypes } from 'invision-core/src/components/metadata/codes/codes.actions';
import { DASHBOARD_ROUTE } from '../../../../../reducers/constants/dashboard.constants';
import { MetadataCodeLoadedSelector, MetadataCodeTypeIntegerSelector, MetadataCodeTypeSelector, MetadataOptionsForCodeValuesWithoutPlaceholderSelector, SubscriberCategoryRequirementsForCurrentBusinessUnitOrDefault, SubscriberRequirementsForCurrentBusinessUnitOrDefault } from 'invision-core/src/components/metadata/codes/codes.selectors';
import { IsConvergentBillerSelector } from 'invision-core/src/components/metadata/codes/codes.selectors.deprecated';
import { LastRouteSelector } from 'invision-core/src/components/session/session.selectors';
import { retrieveOfferingsMetadata } from 'invision-core/src/components/metadata/offerings/offerings.actions';
import { CUSTOMER_URL } from '../../../../customer/customer.config';
import { ShowCustomerAutoPayBannerSelector } from '../../../../../reducers/selectors/customer.account.status.selectors';
import { registerUnsavedChanges, unregisterUnsavedChanges } from 'invision-core/src/components/unsavedChangesPrompt/actions';
import { loadCodeTables } from 'invision-core/src/components/metadata/codes/codes.helpers';
import { IsDbss } from 'invision-core/src/components/session/businessunit.selectors';
import { getShippingMethodsByCountryCode } from 'invision-core/src/components/metadata/shippingMethods/shipping.methods.actions';
import { retrieveConvergentBillerAccountDetails } from '../../../../../reducers/actions/customer.convergent.biller.actions';
import { FullCartOfferingOrderQuotesSelector, FullCartOfferingOrderQuoteTotalSelector, FullCartOfferingOrderFeeQuoteSelector, FullCartOfferingOrderTaxQuoteSelector, FullCartOfferingOrderShippingQuoteSelector, ShowHideFullCartColumnsSelector } from '../../../../../reducers/selectors/full.cart.selectors';
import { AllAttributesAreValidSelector, AttributeServiceSelector, BackButtonTextSelector, CurrentActiveAttributeNameSelector, CustomerInfoSelector, FilteredFormAttributeGroups, FilteredPhysicalAttributeGroups, FinancedProductGroupInCartSelector, FormAttributeGroups, FormPhysicalAttributeGroups, ForwardButtonTextSelector, FormattedNameSelector, GoToPreviousStepIsValidSelector, HasRequiredAndUnavailableInventorySelector, IsFetchingAnyDataSelector, ShowNextButtonSelector, ShowPreviousButtonSelector, StepProgressBarViewModelSelector, SummaryTabViewModel, UnavailablePhysicalInventorySelector } from './edit.offer.wizard.selectors';
import { beginEditOfferOrder, cancelOrder, editOfferSubmitCosOrder, fetchAddresses, fetchAttributes, fetchAttributesQuote, fetchPreviousAttributesAndNavigate, fetchPreviousDecisionsAndNavigate, fetchWallet, goToNextStep, goToPreviousStep, goToStep, resumeStoreOrder, saveOptionEdit, saveBulkPricing, searchAttributeInventory, sendPortInOrItemReservation, setCurrentStepIsInvalid, setDecisionsRequiringAffectedServicesResolution, setEditAttributeGroups, setEditOption, setEditCartAdditionalProperty, setEditCartAdditionalPropertyOnChange, setEditOrderAdditionalProperty, setEditOrderAdditionalPropertyOnChange, setEditPhysicalAttributeGroups, setIsResumingOrder, setIsResumingStoreOrderForEditOffer, setPaymentInfo, setSelectedTab, updateAttribute, updateBillCycle, updateCart, updateEditOptionPrice, updateInventorySelection, updateOfferPhysicalInventoryMakeAndModel, updateOfferPhysicalInventoryTypeAttribute, updatePaymentInfo, updatePortInRequest, updateSelectedServiceFeatures, updateServiceTaxLocationDecisionEditOffer } from '../../../../../reducers/actions/edit.offer.wizard.actions';
import { AvailableCreditFromQuoteSelector, AvailableFinanceCreditFromQuoteSelector, BillingAddressStateRegionProvinceValueOptionsSelector, CartAdditionalPropertiesSelector, CartAdditionalPropertyListMapSelector, CompletedStepsSelector, CurrentRecurringSelector, CurrentStepIsInvalidSelector, CurrentStepSelector, CurrentStepIndexSelector, DeliveryOptionsByPricingPlanSelector, EditOptionSelector, EditOptionsSelector, EditOfferDeliveryMethodOptionsSelector, EditOfferingIdSelector, EditOfferingInstanceIdSelector, FormattedAttributesSelector, FormattedDeliveryDecisionsSelector, FormattedPhysicalAttributesSelector, FormattedCityStateSelector, InventoryAvailabilityRequestsSelector, IsAttributesStepSelector, IsCheckoutStepSelector, IsCreditLimitBreachedFromQuoteSelector, IsDecisionsStepSelector, IsInsufficientChargeOverrideAccessWarningSelector, IsResumingStoreOrderSelector, IsSendToStoreButtonEnabledSelector, IsSubmittingOrderSelector, OrderAdditionalPropertiesSelector, OrderAdditionalPropertyListMapSelector, PaymentInfoEditSelector, ServiceTaxDecisionsSelector, IsSubscriberProductIdUndefinedSelector, IsShippingRequiredSelector, QuoteHasInvoiceItemsSelector, ShippingAddressSelector, ShippingAddressDropdownOptionsSelector, SelectedOfferIdSelector, SelectedTabIndexSelector, ServiceAddressSelector, TabPanelViewModelSelector, TaxLocationDecisionsByPricingPlanEditOfferSelector } from '../../../../../reducers/selectors/edit.offer.wizard.selectors';
import { CurrentCustomerCreditLimitSelector, CurrentCustomerSelector, CurrentCustomerIdSelector, CurrentCustomerIsExternallyManagedARSelector, SelectedCustomerHomeCountrySelector } from '../../../../../reducers/selectors/customer.selectors';
import { STATE_OR_NAME } from '../../../../../reducers/constants/edit.offer.wizard.constants';
import { DELIVERY_OPTIONS, EXISTING_SAVED_CART_FOR_SEND_TO_STORE_FAULT_CODE, INVENTORY_ITEM_RESERVATION_FAULT_CODE, ORDER_SCENARIOS, RETRIEVE_ORDER_QUOTE_COUNTDOWN_DURATION } from '../../../../../customercare.constants';
import { calculateChangeOfServiceOfferingOrderQuote, decisionOptionQuantityChanged, decisionOptionServiceIdsForRemovalSelected, resetAvailableInventoryInformation, retrieveOffCycleNextRenewalSchedules, retrieveOfferingOrderQuote, retrieveOrderQuote, searchAvailableOfferings, searchInventoriesAvailability, sendInventoryToStore, setActiveAttributeFormName, setAttributeFormSubmitted, setDevicePaymentOptions, setInventoryRegionFilter, setSelectedInventoryStores } from '../../../../../reducers/actions/offering.order.actions';
import { DbssShippingEnabledRegionIdSelector, FullCartAsyncStatusSelector, InventoryStorePickupDetailsSelector, InventoryStoresTableDataSelector, IsAsyncCompleteSelector, IsFetchingSelector, IsFullCartAsyncCompleteSelector, IsInventoryStoreConfiguredSelector, IsQuoteBypassedSelector, IsQuotingOfferSelector, OffcycleRenewalScheduleSelector, OfferingOrderAsyncIdSelector, OfferingOrderQuoteSelector, QuoteCalculatedSelector, SelectedDeliveryDecisionSelector, SelectedInventoryRegionSelector, SelectedInventoryStoresDetailsSelector, SelectedOrderDetailsSelector, SelectedOrderExecutionOptionsSelector, SelectedShippingAddressAndMethodSelector, SubscriptionOrderQuoteSelector } from '../../../../../reducers/selectors/offering.order.selectors';
import { AddItemsSelector, AllPhysicalInventoryItemsFromSelectedOffering, AreAnyInventoryUnavailableSelector, AttributeFormSubmittedSelector, AttributeGroupsSelector, CartContainsOffcycleOfferSelector, CompletedDecisionsSelector, DecisionsGroupEmptySelector, DecisionsHasErrorSelector, DecisionsRequireAffectedServicesResolutionSelector, DecisionsRequiringAffectedServicesResolutionSelector, FilteredStoresOnSelectedRegionForStoresSearchModalSelector, HasBulkShoppingCartItem, HasOffCycleChargeRenewalSelector, IsAllSelectedPhysicalInventoryPresentAtSelectedStore, InventoryAvailabilitySelector, IsUpdatingCartSelector, ModifyItemsSelector, PagesWithDecisionsSelector, PaymentInstrumentRequiredSelector, PhysicalAttributeGroupsSelector, RemoveItemsSelector, SelectedOfferChangesEffectiveSelector, SelectedOfferingPhysicalInventoryAvailabilitySelector, SelectedOfferingPickupIdSelector, SelectedOfferingServiceIdentifiersSelector, SelectedOfferingStoreAvailabilitySelector, SelectedOfferPaymentInstrumentSelector, ServicesBeingRemovedHaveServiceFeaturesSelector, ShoppingCartIsPostpaidSelector, ShoppingCartSelector, SubmittedOrderCurrencyCodeSelector, SubmittedOrderErrorSelector, SubmittedOrderSelector } from '../../../../../reducers/selectors/selected.offering.order.selectors';
import { EwalletErrorSelector, SelectedPaymentAutoPayEnable, SelectedPaymentForSubmitAtCheckoutSelector, SelectedPaymentMethodSelector, RecordPaymentInformationSelector, SupplyPaymentInstrumentSelector } from '../../../../../reducers/selectors/customer.ewallet.selectors';
import { duplicatedServiceIdentifierAttributes, markDecisionsRequiringAffectedServicesResolutionAsResolved } from '../../../../../reducers/helpers/offer.ordering.wizard.helper';
import { setSelectedContract } from '../../../../../reducers/actions/contract.details.actions';
import CustomerCareKeys from '../../../../../locales/keys';
import { cancelStoreOrder, setCustomerCategory } from '../../../../../reducers/actions/customer.actions';
import { resetMobileNumberPortabilityModels } from '../../../../../reducers/actions/mobile.number.portability.actions';
import { setCustomerAutoPayBannerFlag } from '../../../../../reducers/actions/customer.account.status.actions';
import { setForceShowEditFormAddress, validateAddress } from '../../../../../reducers/actions/address.component.actions';
import { ValidatedAddressesSelector, UnvalidatedAddressesSelector } from '../../../../../reducers/selectors/address.component.selectors';
import { isAddressValidFromAddressResponse } from '../../../../shared/contextualComponents/address/address.validator.helper';
import { OfferWizard } from '../../offer.wizard.common';
import { ContextOfferingAction } from '../../../../../reducers/constants/wizard.constants';
import { MINI_CART_MORE_ACTIONS, moreActionMenuItems } from '../../../../wizards/tabs/summaryTab/summary.tab.helper';
import { asyncRepeatInterval } from '../../../../../reducers/helpers/async.helper';
import { FormattedEditCustomerSubscriberIdentitiesSelector } from '../../../../../reducers/selectors/customer.information.selectors';
import { CurrentCustomerNodeSelector } from '../../../../../reducers/selectors/customer.account.hierarchy.selectors';
import { REPORTING_LEVELS } from '../../../accountHierarchy/account.hierarchy.constants';
import { CUSTOMER_CATEGORY } from '../../../../createCustomerPopup/create.customer.popup.constants';
var EditOfferWizardController = /*#__PURE__*/function (_OfferWizard) {
  function EditOfferWizardController($ngRedux, $log, $filter, $state, $timeout, $interval, $element, uiNotificationService, unsavedChangesPrompt) {
    var _this;
    _classCallCheck(this, EditOfferWizardController);
    _this = _callSuper(this, EditOfferWizardController);
    Object.assign(_this, {
      $element: $element,
      $filter: $filter,
      $interval: $interval,
      $log: $log,
      $ngRedux: $ngRedux,
      $state: $state,
      $timeout: $timeout,
      _previewRenewalStatementsPopupApi: null,
      cartMessages: [CustomerCareKeys.CART_SUMMARY.QUOTE_SUMMARY],
      CustomerCareKeys: CustomerCareKeys,
      customerCategory: CUSTOMER_CATEGORY,
      DELIVERY_OPTIONS: DELIVERY_OPTIONS,
      initialServiceFeatures: {},
      intendedDecisionsPage: null,
      intendedDecisionsPageWhenDecisionAffectedServicesResolved: null,
      isLoadingPage: true,
      miniCartMoreActionMenuItems: moreActionMenuItems([MINI_CART_MORE_ACTIONS.EDIT_SINGLE_OFFER]),
      ORDER_SCENARIOS: ORDER_SCENARIOS,
      overrideBypassQuoteConfiguration: false,
      proceedToAttributesStepWhenDecisionAffectedServicesResolved: false,
      retrieveOfferingOrderQuoteTimestamp: null,
      retrieveOrderQuoteTimestamp: null,
      REPORTING_LEVELS: REPORTING_LEVELS,
      showSendToStorePopup: false,
      showPreviewRenewalStatementsDialog: false,
      showSelectAffectedServicesPopup: false,
      STATE_OR_NAME: STATE_OR_NAME,
      uiNotificationService: uiNotificationService,
      unsavedChangesPrompt: unsavedChangesPrompt,
      isReconnectOffer: $state.params.reconnectOffer,
      applyDecisionAffectedServicesResolutionsCallback: _this.applyDecisionAffectedServicesResolutionsCallback.bind(_this),
      attemptNextStep: _this.attemptNextStep.bind(_this),
      beginResolveDecisionAffectedServicesCallback: _this.beginResolveDecisionAffectedServicesCallback.bind(_this),
      cancelResolveDecisionAffectedServicesCallback: _this.cancelResolveDecisionAffectedServicesCallback.bind(_this),
      closeSearchInventoryPopupDialog: _this.closeSearchInventoryPopupDialog.bind(_this),
      closeSelectStorePopupDialog: _this.closeSelectStorePopupDialog.bind(_this),
      closeSendToStorePopup: _this.closeSendToStorePopup.bind(_this),
      closeViewFullCartPopupDialog: _this.closeViewFullCartPopupDialog.bind(_this),
      handleClosePreviewRenewalStatementsDialog: _this.handleClosePreviewRenewalStatementsDialog.bind(_this),
      handleCloseSubmitOrderErrorPopup: _this.handleCloseSubmitOrderErrorPopup.bind(_this),
      handleInventoryAvailabilityContinue: _this.handleInventoryAvailabilityContinue.bind(_this),
      handlePreviewRenewalStatements: _this.handlePreviewRenewalStatements.bind(_this),
      handleResultUnsavedChangesPromptPopup: _this.handleResultUnsavedChangesPromptPopup.bind(_this),
      handleSubmitForPickupCancel: _this.handleSubmitForPickupCancel.bind(_this),
      handleSubmitForPickupErrorPopup: _this.handleSubmitForPickupErrorPopup.bind(_this),
      onCartAdditionalPropertyChanged: _this.onCartAdditionalPropertyChanged.bind(_this),
      onCartAdditionalPropertyListUpdated: _this.onCartAdditionalPropertyListUpdated.bind(_this),
      onInventoryRegionFilterChanged: _this.onInventoryRegionFilterChanged.bind(_this),
      onInventoryRegionFilterChangedForStoreSearch: _this.onInventoryRegionFilterChangedForStoreSearch.bind(_this),
      onMoreActionSelected: _this.onMoreActionSelected.bind(_this),
      onOrderAdditionalPropertyChanged: _this.onOrderAdditionalPropertyChanged.bind(_this),
      onOrderAdditionalPropertyListUpdated: _this.onOrderAdditionalPropertyListUpdated.bind(_this),
      onOverrideCalculateQuote: _this.onOverrideCalculateQuote.bind(_this),
      onRefreshOfferingQuote: _this.onRefreshOfferingQuote.bind(_this),
      onRefreshQuote: _this.onRefreshQuote.bind(_this),
      onSelectInventoryStore: _this.onSelectInventoryStore.bind(_this),
      onUpdateSelectedServiceFeatures: _this.onUpdateSelectedServiceFeatures.bind(_this),
      openStoreSearch: _this.openStoreSearch.bind(_this),
      recalculateOrderQuote: _this.recalculateOrderQuote.bind(_this),
      recallOfferingContext: _this.recallOfferingContext.bind(_this),
      repeatRetrieveOfferingQuote: _this.repeatRetrieveOfferingQuote.bind(_this),
      repeatRetrieveQuote: _this.repeatRetrieveQuote.bind(_this),
      sendToStore: _this.sendToStore.bind(_this),
      setSelectedStoreForSearchModal: _this.setSelectedStoreForSearchModal.bind(_this),
      updateCart: _this.updateCart.bind(_this)
    });
    Promise.all(loadCodeTables(_this.$ngRedux.getState(), _this.$ngRedux.dispatch, [CODES.FinanceBillerRuleConfiguration, CODES.InventoryRegion, CODES.OneTimeBillerRuleConfiguration, CODES.PeriodType, CODES.ReasonCodes, CODES.RecurringBillerRuleConfiguration, CODES.Stores])).catch(function (error) {
      _this.uiNotificationService.transientError(error.translatedMessage);
    });
    return _this;
  }
  _inherits(EditOfferWizardController, _OfferWizard);
  return _createClass(EditOfferWizardController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this2 = this;
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          addItems: AddItemsSelector(store),
          additionalPropValueOptions: MetadataCodeTypeIntegerSelector(CODES.AdditionalPropertyValue, store),
          addressStates: BillingAddressStateRegionProvinceValueOptionsSelector(store),
          allAttributesAreValid: AllAttributesAreValidSelector(store),
          areAnyInventoryUnavailable: AreAnyInventoryUnavailableSelector(store),
          attributeFormSubmitted: AttributeFormSubmittedSelector(store),
          attributeGroups: AttributeGroupsSelector(store),
          availableCreditFromQuote: AvailableCreditFromQuoteSelector(store),
          availableFinanceCreditFromQuote: AvailableFinanceCreditFromQuoteSelector(store),
          availableInventoryInformation: InventoryAvailabilitySelector(store),
          backButtonText: BackButtonTextSelector(store),
          cartAdditionalProperties: CartAdditionalPropertiesSelector(store),
          cartAdditionalPropertyListMap: CartAdditionalPropertyListMapSelector(store),
          cartContainsOffcycleOffer: CartContainsOffcycleOfferSelector(store),
          changesEffective: SelectedOfferChangesEffectiveSelector(store),
          codeTypeLoaded: MetadataCodeLoadedSelector(__, store),
          completedDecisions: CompletedDecisionsSelector(store),
          completedSteps: CompletedStepsSelector(store),
          createdOrder: SubmittedOrderSelector(store),
          createOrderError: SubmittedOrderErrorSelector(store),
          currencyCode: SubmittedOrderCurrencyCodeSelector(store),
          currentAttributeTitle: CurrentActiveAttributeNameSelector(store),
          currentCustomer: CurrentCustomerSelector(store),
          currentCustomerCreditLimit: CurrentCustomerCreditLimitSelector(store),
          currentCustomerIsExternallyManagedAR: CurrentCustomerIsExternallyManagedARSelector(store),
          currentCustomerNode: CurrentCustomerNodeSelector(store),
          currentRecurring: CurrentRecurringSelector(store),
          currentStep: CurrentStepSelector(store),
          currentStepIndex: CurrentStepIndexSelector(store),
          currentStepIsInvalid: CurrentStepIsInvalidSelector(store),
          customerId: CurrentCustomerIdSelector(store),
          customerInfo: CustomerInfoSelector(store),
          dbssShippingEnabledRegionId: DbssShippingEnabledRegionIdSelector(store),
          decisionsHasValidationError: DecisionsHasErrorSelector(store),
          decisionsRequireAffectedServicesResolution: DecisionsRequireAffectedServicesResolutionSelector(store),
          decisionsRequiringAffectedServicesResolution: DecisionsRequiringAffectedServicesResolutionSelector(store),
          deliveryMethodOptions: EditOfferDeliveryMethodOptionsSelector(store),
          deliveryOptionsByPricingPlan: DeliveryOptionsByPricingPlanSelector(store),
          editOption: EditOptionSelector(store),
          editOptions: EditOptionsSelector(store),
          editOfferingId: EditOfferingIdSelector(store),
          editOfferingInstanceId: EditOfferingInstanceIdSelector(store),
          emptyDecisionGroups: DecisionsGroupEmptySelector(store),
          executionOptions: SelectedOrderExecutionOptionsSelector(store),
          filteredFormAttributeGroups: FilteredFormAttributeGroups(store),
          filteredPhysicalAttributeGroups: FilteredPhysicalAttributeGroups(store),
          filteredStoresOnSelectedRegionForStoresSearchModal: FilteredStoresOnSelectedRegionForStoresSearchModalSelector(store),
          financedProductGroupInCart: FinancedProductGroupInCartSelector(store),
          formattedEditCustomerSubscriberIdentities: FormattedEditCustomerSubscriberIdentitiesSelector(store),
          formattedAttributes: FormattedAttributesSelector(store),
          formattedCityState: FormattedCityStateSelector(store),
          formattedDeliveryDecisions: FormattedDeliveryDecisionsSelector(store),
          formattedName: FormattedNameSelector(store),
          formattedPhysicalAttributes: FormattedPhysicalAttributesSelector(store),
          formattedPhysicalInventories: SelectedOfferingPhysicalInventoryAvailabilitySelector(store),
          formAttributeGroups: FormAttributeGroups(store),
          formPhysicalAttributeGroups: FormPhysicalAttributeGroups(store),
          forwardButtonText: ForwardButtonTextSelector(store),
          fullCartAsyncStatus: FullCartAsyncStatusSelector(store),
          fullCartOfferingOrderQuotes: FullCartOfferingOrderQuotesSelector(store),
          fullCartOfferingOrderQuoteTotal: FullCartOfferingOrderQuoteTotalSelector(store),
          fullCartOfferingOrderFeeQuote: FullCartOfferingOrderFeeQuoteSelector(store),
          fullCartOfferingOrderTaxQuote: FullCartOfferingOrderTaxQuoteSelector(store),
          fullCartOfferingOrderShippingQuote: FullCartOfferingOrderShippingQuoteSelector(store),
          goToPreviousStepIsValid: GoToPreviousStepIsValidSelector(store),
          hasBulkShoppingCartItem: HasBulkShoppingCartItem(store),
          hasInvoiceItems: QuoteHasInvoiceItemsSelector(store),
          hasOffCycleChargeRenewal: HasOffCycleChargeRenewalSelector(store),
          hasRequiredAndUnavailableInventory: HasRequiredAndUnavailableInventorySelector(store),
          inventoryAvailabilityRequests: InventoryAvailabilityRequestsSelector(store),
          inventoryRegions: MetadataOptionsForCodeValuesWithoutPlaceholderSelector(CODES.InventoryRegion, store),
          inventoryStorePickupDetails: InventoryStorePickupDetailsSelector(store),
          isAllSelectedPhysicalInventoryAvailable: IsAllSelectedPhysicalInventoryPresentAtSelectedStore(store),
          isAttributesStep: IsAttributesStepSelector(store),
          isCheckoutStep: IsCheckoutStepSelector(store),
          isConvergentBiller: IsConvergentBillerSelector(store),
          isCreditLimitBreached: IsCreditLimitBreachedFromQuoteSelector(store),
          isDbss: IsDbss(store),
          isDecisionsStep: IsDecisionsStepSelector(store),
          isFetchingOfferOrder: IsFetchingSelector(store),
          isFetchingAnyData: IsFetchingAnyDataSelector(store),
          isFullCartAsyncComplete: IsFullCartAsyncCompleteSelector(store),
          isInsufficientChargeOverrideAccessWarning: IsInsufficientChargeOverrideAccessWarningSelector(store),
          isInventoryStoreConfigured: IsInventoryStoreConfiguredSelector(store),
          isPaymentInstrumentRequired: PaymentInstrumentRequiredSelector(store),
          isQuoteBypassed: IsQuoteBypassedSelector(store),
          isQuoteCalculated: QuoteCalculatedSelector(store),
          isAsyncComplete: IsAsyncCompleteSelector(store),
          isQuotingOffer: IsQuotingOfferSelector(store),
          //TO-DO verify below doesn't break on customer step
          isResumingStoreOrder: IsResumingStoreOrderSelector(store),
          isSendToStoreButtonEnabled: IsSendToStoreButtonEnabledSelector(store),
          isShippingRequired: IsShippingRequiredSelector(store),
          isSubmittingOrder: IsSubmittingOrderSelector(store),
          isUpdatingCart: IsUpdatingCartSelector(store),
          lastAttemptError: SubmittedOrderErrorSelector(store),
          lastRoute: LastRouteSelector(store),
          modifyItems: ModifyItemsSelector(store),
          orderDetails: SelectedOrderDetailsSelector(store),
          offcycleRenewalSchedule: OffcycleRenewalScheduleSelector(store),
          offeringOrderAsyncId: OfferingOrderAsyncIdSelector(store),
          offeringOrderQuote: OfferingOrderQuoteSelector(store),
          orderAdditionalProperties: OrderAdditionalPropertiesSelector(store),
          orderAdditionalPropertyListMap: OrderAdditionalPropertyListMapSelector(store),
          pagesWithDecisions: PagesWithDecisionsSelector(store),
          paymentInfo: SelectedOfferPaymentInstrumentSelector(store),
          paymentInfoEdit: PaymentInfoEditSelector(store),
          paymentInstrumentRequired: PaymentInstrumentRequiredSelector(store),
          periodTypes: MetadataCodeTypeSelector(CODES.PeriodType, store),
          physicalAttributeGroups: PhysicalAttributeGroupsSelector(store),
          serviceTaxDecisions: ServiceTaxDecisionsSelector(store),
          isSubscriberProductIdUndefined: IsSubscriberProductIdUndefinedSelector(store),
          physicalInventories: AllPhysicalInventoryItemsFromSelectedOffering(store),
          recordPaymentInfo: RecordPaymentInformationSelector(store),
          removeItems: RemoveItemsSelector(store),
          retrieveEwalletError: EwalletErrorSelector(store),
          shippingAddress: ShippingAddressSelector(store),
          selectedCustomerHomeCountry: SelectedCustomerHomeCountrySelector(store),
          selectedDeliveryDecision: SelectedDeliveryDecisionSelector(store),
          selectedInventoryRegion: SelectedInventoryRegionSelector(store),
          selectedInventoryStores: SelectedInventoryStoresDetailsSelector(store),
          selectedInventoryStoresItemAvailability: SelectedOfferingStoreAvailabilitySelector(store),
          selectedOfferId: SelectedOfferIdSelector(store),
          selectedOfferingServiceIdentifiers: SelectedOfferingServiceIdentifiersSelector(store),
          selectedPayment: SelectedPaymentMethodSelector(store),
          selectedPaymentClean: SelectedPaymentForSubmitAtCheckoutSelector(store),
          selectedPaymentMethodAutoPay: SelectedPaymentAutoPayEnable(store),
          selectedOfferingPickupId: SelectedOfferingPickupIdSelector(store),
          selectedShippingAddressAndMethod: SelectedShippingAddressAndMethodSelector(store),
          selectedTabIndex: SelectedTabIndexSelector(store),
          serviceAddress: ServiceAddressSelector(store),
          services: AttributeServiceSelector(store),
          servicesBeingRemovedHaveServiceFeatures: ServicesBeingRemovedHaveServiceFeaturesSelector(store),
          shippingAddressDropdownOptions: ShippingAddressDropdownOptionsSelector(store),
          shoppingCart: ShoppingCartSelector(store),
          shoppingCartIsPostpaid: ShoppingCartIsPostpaidSelector(store),
          shouldShowNextButton: ShowNextButtonSelector(store),
          shouldShowPreviousButton: ShowPreviousButtonSelector(store),
          showCustomerAutoPayBanner: ShowCustomerAutoPayBannerSelector(store),
          showHideFullCartColumns: ShowHideFullCartColumnsSelector(store),
          stepsProgressBarViewModel: StepProgressBarViewModelSelector(store),
          storesTableData: InventoryStoresTableDataSelector(store),
          subscriptionOrderQuotes: SubscriptionOrderQuoteSelector(store),
          subscriberCategoryRequirements: SubscriberCategoryRequirementsForCurrentBusinessUnitOrDefault(store),
          subscriberRequirements: SubscriberRequirementsForCurrentBusinessUnitOrDefault(store),
          summaryTabViewModel: SummaryTabViewModel(store),
          supplyPaymentInstrument: SupplyPaymentInstrumentSelector(store),
          tabs: TabPanelViewModelSelector(store),
          taxLocationDecisionsByPricingPlanEditOffer: TaxLocationDecisionsByPricingPlanEditOfferSelector(store),
          unavailablePhysicalInventory: UnavailablePhysicalInventorySelector(store),
          unvalidatedAddresses: UnvalidatedAddressesSelector(store),
          validatedAddresses: ValidatedAddressesSelector(store)
        };
      };
      var controllerActions = {
        beginEditOfferOrder: beginEditOfferOrder,
        calculateChangeOfServiceOfferingOrderQuote: calculateChangeOfServiceOfferingOrderQuote,
        cancelOrder: cancelOrder,
        cancelStoreOrder: cancelStoreOrder,
        decisionOptionQuantityChanged: decisionOptionQuantityChanged,
        decisionOptionServiceIdsForRemovalSelected: decisionOptionServiceIdsForRemovalSelected,
        editOfferSubmitCosOrder: editOfferSubmitCosOrder,
        fetchAddresses: fetchAddresses,
        fetchAttributes: fetchAttributes,
        fetchAttributesQuote: fetchAttributesQuote,
        fetchCodeTypes: fetchCodeTypes,
        fetchPreviousAttributesAndNavigate: fetchPreviousAttributesAndNavigate,
        fetchPreviousDecisionsAndNavigate: fetchPreviousDecisionsAndNavigate,
        fetchWallet: fetchWallet,
        getShippingMethodsByCountryCode: getShippingMethodsByCountryCode,
        goToNextStep: goToNextStep,
        goToPreviousStep: goToPreviousStep,
        goToStep: goToStep,
        registerUnsavedChanges: registerUnsavedChanges,
        resetAvailableInventoryInformation: resetAvailableInventoryInformation,
        resetMobileNumberPortabilityModels: resetMobileNumberPortabilityModels,
        resumeStoreOrder: resumeStoreOrder,
        retrieveConvergentBillerAccountDetails: retrieveConvergentBillerAccountDetails,
        retrieveOffCycleNextRenewalSchedules: retrieveOffCycleNextRenewalSchedules,
        retrieveOfferingOrderQuote: retrieveOfferingOrderQuote,
        retrieveOfferingsMetadata: retrieveOfferingsMetadata,
        retrieveOrderQuote: retrieveOrderQuote,
        saveOptionEdit: saveOptionEdit,
        saveBulkPricing: saveBulkPricing,
        searchAttributeInventory: searchAttributeInventory,
        searchAvailableOfferings: searchAvailableOfferings,
        searchInventoriesAvailability: searchInventoriesAvailability,
        sendInventoryToStore: sendInventoryToStore,
        sendPortInOrItemReservation: sendPortInOrItemReservation,
        setActiveAttributeFormName: setActiveAttributeFormName,
        setAttributeFormSubmitted: setAttributeFormSubmitted,
        setCurrentStepIsInvalid: setCurrentStepIsInvalid,
        setCustomerAutoPayBannerFlag: setCustomerAutoPayBannerFlag,
        setCustomerCategory: setCustomerCategory,
        setDecisionsRequiringAffectedServicesResolution: setDecisionsRequiringAffectedServicesResolution,
        setDevicePaymentOptions: setDevicePaymentOptions,
        setEditAttributeGroups: setEditAttributeGroups,
        setEditOption: setEditOption,
        setEditCartAdditionalProperty: setEditCartAdditionalProperty,
        setEditCartAdditionalPropertyOnChange: setEditCartAdditionalPropertyOnChange,
        setEditOrderAdditionalProperty: setEditOrderAdditionalProperty,
        setEditOrderAdditionalPropertyOnChange: setEditOrderAdditionalPropertyOnChange,
        setEditPhysicalAttributeGroups: setEditPhysicalAttributeGroups,
        setForceShowEditFormAddress: setForceShowEditFormAddress,
        setInventoryRegionFilter: setInventoryRegionFilter,
        setIsResumingOrder: setIsResumingOrder,
        setIsResumingStoreOrderForEditOffer: setIsResumingStoreOrderForEditOffer,
        setPaymentInfo: setPaymentInfo,
        setSelectedContract: setSelectedContract,
        setSelectedInventoryStores: setSelectedInventoryStores,
        setSelectedTab: setSelectedTab,
        unregisterUnsavedChanges: unregisterUnsavedChanges,
        updateAttribute: updateAttribute,
        updateBillCycle: updateBillCycle,
        updateCart: updateCart,
        updateEditOptionPrice: updateEditOptionPrice,
        updateInventorySelection: updateInventorySelection,
        updateOfferPhysicalInventoryMakeAndModel: updateOfferPhysicalInventoryMakeAndModel,
        updateOfferPhysicalInventoryTypeAttribute: updateOfferPhysicalInventoryTypeAttribute,
        updatePaymentInfo: updatePaymentInfo,
        updatePortInRequest: updatePortInRequest,
        updateSelectedServiceFeatures: updateSelectedServiceFeatures,
        updateServiceTaxLocationDecisionEditOffer: updateServiceTaxLocationDecisionEditOffer,
        validateAddress: validateAddress
      };
      this.disconnectRedux = this.connectToStore(mapStateToTarget, controllerActions);
      var promises = [];
      this.actions.beginEditOfferOrder();
      if (this.state.customerInfo.ConvergentBillerId) {
        promises.push(this.actions.retrieveConvergentBillerAccountDetails(this.state.customerId));
      }
      promises.push(this.actions.fetchPreviousDecisionsAndNavigate(this.state.customerId, this.state.editOfferingId, this.state.editOfferingInstanceId, null, this.state.isConvergentBiller, this.isReconnectOffer).then(function () {
        if (pathOr(false, ['Items', '0', 'OrderContractInstance'], _this2.state.shoppingCart)) {
          _this2.actions.setSelectedContract(_this2.state.shoppingCart.Items[0].OrderContractInstance);
        }
        if (_this2.state.isInsufficientChargeOverrideAccessWarning && _this2.isReconnectOffer) {
          _this2.openInsufficientPermissionsWarningPopup();
        }
        _this2.actions.retrieveOfferingsMetadata([_this2.state.selectedOfferId]);
        return !_this2.state.isResumingStoreOrder ? _this2.searchAvailableOfferings() : _this2.actions.resumeStoreOrder(_this2.state.customerInfo).then(function () {
          return _this2.actions.calculateChangeOfServiceOfferingOrderQuote(_this2.state.customerInfo, _this2.state.editOfferingId, _this2.state.shoppingCart.AddItems, _this2.state.shoppingCart.RemoveItems, _this2.state.shoppingCart.ModifyItems, _this2.state.executionOptions, _this2.isReconnectOffer, _this2.state.selectedShippingAddressAndMethod, !!_this2.state.shippingAddress, _this2.overrideBypassQuoteConfiguration).then(function () {
            _this2.actions.goToStep(CustomerCareKeys.WIZARD.STEPS.CHECKOUT);
          });
        });
      }).catch(function () {
        _this2.state.lastRoute.name ? _this2.$state.go(_this2.state.lastRoute.name, _this2.state.lastRoute.params) : _this2.redirectToCustomer();
      }));
      promises.push(this.actions.fetchAddresses(this.state.customerInfo.Id));
      this.actions.setCustomerCategory(this.state.customerInfo.Category);
      promises.push(this.actions.fetchWallet(this.state.customerId).catch(function () {
        if (_this2.state.retrieveEwalletError) {
          _this2.uiNotificationService.error(_this2.state.retrieveEwalletError.message);
        }
      }));
      if (this.state.isDbss) {
        promises.push(this.actions.getShippingMethodsByCountryCode(this.state.selectedCustomerHomeCountry).catch(function (error) {
          _this2.uiNotificationService.transientError(error.translatedMessage);
        }));
      }
      Promise.all(promises).finally(function () {
        _this2.$timeout(function () {
          _this2.isLoadingPage = false;
        });
      });
      this.insufficientPermissionsWarningPopup = {
        onRegisterApi: function onRegisterApi(event) {
          _this2.insufficientPermissionsWarningPopup = event.api;
        }
      };
      this.openInsufficientPermissionsWarningPopup = function () {
        _this2.insufficientPermissionsWarningPopup.open();
      };
      this.closeInsufficientPermissionsWarningPopup = function () {
        _this2.insufficientPermissionsWarningPopup.close();
        _this2.goBackToDashboard();
      };
      this.goBackToDashboard = function () {
        var route = DASHBOARD_ROUTE;
        var params = _this2.state.lastRoute.params || {};
        _this2.$state.go(route, params);
      };

      //hook the popupApi
      this.unsavedChangesPromptPopupConfig = {
        onRegisterApi: function onRegisterApi(_ref) {
          var api = _ref.api;
          _this2.unsavedChangesPromptPopupApi = api;
        }
      };

      // hook the order confirmation popupApi
      this.orderConfirmationPopup = {
        onRegisterApi: function onRegisterApi(_ref2) {
          var api = _ref2.api;
          _this2.orderConfirmationPopup = api;
        }
      };

      // hook the submit order error popupApi
      this.submitOrderErrorPopupConfig = {
        onRegisterApi: function onRegisterApi(_ref3) {
          var api = _ref3.api;
          _this2.submitOrderErrorPopupApi = api;
        }
      };

      // hook the submit order error popupApi
      this.submitForPickupErrorPopupConfig = {
        onRegisterApi: function onRegisterApi(_ref4) {
          var api = _ref4.api;
          _this2.submitForPickupErrorPopupApi = api;
        }
      };
      this.creditCheckPopupConfig = {
        onRegisterApi: function onRegisterApi(_ref5) {
          var api = _ref5.api;
          _this2.creditCheckPopupApi = api;
        }
      };
      this.viewFullCartPopupConfig = {
        onRegisterApi: function onRegisterApi(event) {
          _this2.viewFullCartPopupApi = event.api;
        }
      };
      this.previewRenewalStatementsPopupConfig = {
        onRegisterApi: function onRegisterApi(event) {
          _this2._previewRenewalStatementsPopupApi = event.api;
        }
      };
      this.selectStorePopupConfig = {
        onRegisterApi: function onRegisterApi(_ref6) {
          var api = _ref6.api;
          _this2.selectStorePopupApi = api;
        }
      };
      this.storeSearchInventoryConfig = {
        onRegisterApi: function onRegisterApi(_ref7) {
          var api = _ref7.api;
          _this2.storeSearchInventoryApi = api;
        }
      };
      this.openCreditCheckModal = function () {
        _this2.creditCheckPopupApi.open();
      };
      this.sendToStorePopupConfig = {
        onRegisterApi: function onRegisterApi(_ref8) {
          var api = _ref8.api;
          _this2.sendToStorePopupApi = api;
        }
      };
    }
  }, {
    key: "handleResultUnsavedChangesPromptPopup",
    value: function handleResultUnsavedChangesPromptPopup(confirmed) {
      if (confirmed) {
        this.handleCancel();
      }
      this.unsavedChangesPromptPopupApi.close();
    }
  }, {
    key: "openViewFullCartPopupDialog",
    value: function openViewFullCartPopupDialog() {
      this.showViewFullCartPopup = true;
      this.$timeout(this.viewFullCartPopupApi.open);
    }
  }, {
    key: "recallOfferingContext",
    value: function recallOfferingContext() {
      var _this3 = this;
      this.actions.fetchAttributes({
        completedAttributes: this.state.formattedAttributes,
        completedDecisions: this.getCompletedDecisions(),
        completedPhysicalAttributes: this.state.formattedPhysicalAttributes,
        isConvergentBiller: this.state.isConvergentBiller,
        isEditOffer: true,
        isReconnectAction: this.isReconnectOffer,
        offeringId: this.state.selectedOfferId,
        offeringInstanceId: this.state.editOfferingInstanceId
      }).catch(function (err) {
        _this3.uiNotificationService.transientError(err.translatedMessage);
      });
    }
  }, {
    key: "onOverrideCalculateQuote",
    value: function onOverrideCalculateQuote() {
      this.overrideBypassQuoteConfiguration = true;
      this.recalculateOrderQuote();
    }
  }, {
    key: "onViewFullCartRequest",
    value: function onViewFullCartRequest() {
      var _this4 = this;
      if (this.state.offeringOrderAsyncId) {
        this.repeatRetrieveOfferingQuote();
        this.openViewFullCartPopupDialog();
      } else {
        if (!Object.keys(this.state.offeringOrderQuote).length) {
          this.actions.calculateChangeOfServiceOfferingOrderQuote(this.state.customerInfo, this.state.editOfferingId, this.state.addItems, this.state.removeItems, this.state.modifyItems, this.state.executionOptions, this.isReconnectOffer, this.state.selectedShippingAddressAndMethod, undefined, this.overrideBypassQuoteConfiguration).then(function () {
            if (_this4.state.cartContainsOffcycleOffer) {
              _this4.actions.retrieveOffCycleNextRenewalSchedules(_this4.state.customerInfo.Id, _this4.state.addItems, _this4.state.modifyItems, _this4.state.removeItems).catch(function (error) {
                _this4.uiNotificationService.transientError(error.translatedMessage);
              });
            }
            _this4.openViewFullCartPopupDialog();
          }).catch(function (error) {
            _this4.uiNotificationService.transientError(error.translatedMessage);
          });
        } else {
          if (this.state.cartContainsOffcycleOffer) {
            this.actions.retrieveOffCycleNextRenewalSchedules(this.state.customerInfo.Id, this.state.addItems, this.state.modifyItems, this.state.removeItems).catch(function (error) {
              _this4.uiNotificationService.transientError(error.translatedMessage);
            });
          }
          this.openViewFullCartPopupDialog();
        }
      }
    }
  }, {
    key: "repeatRetrieveQuote",
    value: function repeatRetrieveQuote() {
      var _this5 = this;
      asyncRepeatInterval(this.onRefreshQuote, function () {
        return !_this5.state.isAsyncComplete && _this5.state.isCheckoutStep;
      });
    }
  }, {
    key: "onRefreshQuote",
    value: function onRefreshQuote() {
      var _this6 = this;
      return this.actions.retrieveOfferingOrderQuote(this.state.customerId, this.state.offeringOrderAsyncId).then(function (response) {
        _this6.retrieveOrderQuoteTimestamp = moment().add(RETRIEVE_ORDER_QUOTE_COUNTDOWN_DURATION, 'milliseconds');
        return response;
      }).catch(function (error) {
        _this6.uiNotificationService.transientError(error.translatedMessage);
      });
    }
  }, {
    key: "repeatRetrieveOfferingQuote",
    value: function repeatRetrieveOfferingQuote() {
      var _this7 = this;
      if (this.state.offeringOrderQuote.OfferingQuotes.length > 0 && this.state.isFullCartAsyncComplete) {
        this.openViewFullCartPopupDialog();
      } else {
        asyncRepeatInterval(this.onRefreshOfferingQuote, function () {
          return !_this7.state.isFullCartAsyncComplete && _this7.state.isCheckoutStep;
        });
      }
    }
  }, {
    key: "onRefreshOfferingQuote",
    value: function onRefreshOfferingQuote() {
      var _this8 = this;
      return this.actions.retrieveOfferingOrderQuote(this.state.customerId, this.state.offeringOrderAsyncId).then(function (response) {
        _this8.retrieveOfferingOrderQuoteTimestamp = moment().add(RETRIEVE_ORDER_QUOTE_COUNTDOWN_DURATION, 'milliseconds');
        return response;
      }).catch(function (error) {
        return _this8.uiNotificationService.transientError(error.translatedMessage);
      });
    }
  }, {
    key: "handleCloseUnsavedChangesPromptPopup",
    value: function handleCloseUnsavedChangesPromptPopup() {
      this.unsavedChangesPromptPopupApi.close();
    }
  }, {
    key: "openOrderConfirmationPopup",
    value: function openOrderConfirmationPopup() {
      this.orderConfirmationPopup.open();
    }
  }, {
    key: "handleCloseSubmitOrderErrorPopup",
    value: function handleCloseSubmitOrderErrorPopup() {
      this.submitOrderErrorPopupApi.close();
    }
  }, {
    key: "gotoDecisionsPage",
    value: function gotoDecisionsPage() {
      this.closeViewFullCartPopupDialog();
      this.actions.goToStep(CustomerCareKeys.WIZARD.STEPS.DECISIONS);
    }
  }, {
    key: "handleCancel",
    value: function handleCancel() {
      this.actions.cancelOrder();
      this.deregisterUnsavedChanges();
      if (this.state.lastRoute.name) {
        this.$state.go(this.state.lastRoute.name, this.state.lastRoute.params);
      } else {
        this.redirectToCustomer();
      }
    }
  }, {
    key: "handleSubmitForPickupCancel",
    value: function handleSubmitForPickupCancel() {
      var _this9 = this;
      this.isCancellingSendToStoreCart = true;
      this.submitForPickupErrorPopupApi.close();
      this.actions.cancelStoreOrder(this.state.customerInfo.Id).then(function () {
        _this9.handleSendToStore();
      }).catch(function (error) {
        _this9.uiNotificationService.transientError(error.translatedMessage);
      }).finally(function () {
        _this9.isCancellingSendToStoreCart = false;
      });
    }
  }, {
    key: "handleSubmitForPickupErrorPopup",
    value: function handleSubmitForPickupErrorPopup() {
      this.submitForPickupErrorPopupApi.close();
    }
  }, {
    key: "onCartAdditionalPropertyListUpdated",
    value: function onCartAdditionalPropertyListUpdated() {
      this.actions.setEditCartAdditionalProperty(this.state.cartAdditionalPropertyListMap);
    }
  }, {
    key: "onCartAdditionalPropertyChanged",
    value: function onCartAdditionalPropertyChanged(id, newValue) {
      this.actions.setEditCartAdditionalPropertyOnChange(id, newValue);
    }
  }, {
    key: "onOrderAdditionalPropertyListUpdated",
    value: function onOrderAdditionalPropertyListUpdated() {
      this.actions.setEditOrderAdditionalProperty(this.state.orderAdditionalPropertyListMap);
    }
  }, {
    key: "onOrderAdditionalPropertyChanged",
    value: function onOrderAdditionalPropertyChanged(id, newValue) {
      this.actions.setEditOrderAdditionalPropertyOnChange(id, newValue);
    }
  }, {
    key: "beginResolveDecisionAffectedServicesCallback",
    value: function beginResolveDecisionAffectedServicesCallback(intendedPage) {
      this.intendedDecisionsPage = intendedPage || null;
      this.showSelectAffectedServicesPopup = true;
    }
  }, {
    key: "closeViewFullCartPopupDialog",
    value: function closeViewFullCartPopupDialog() {
      this.showViewFullCartPopup = false;
      this.viewFullCartPopupApi.close();
    }
  }, {
    key: "cancelResolveDecisionAffectedServicesCallback",
    value: function cancelResolveDecisionAffectedServicesCallback() {
      var _this10 = this;
      var hideSelectAffectedServicesPopupOnly = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (!hideSelectAffectedServicesPopupOnly) {
        var canceledDecisions = markDecisionsRequiringAffectedServicesResolutionAsResolved(this.state.decisionsRequiringAffectedServicesResolution);
        this.actions.setDecisionsRequiringAffectedServicesResolution(canceledDecisions);
        canceledDecisions.forEach(function (decision) {
          var originalQuantity = decision.updatedQuantity + decision.numRequiredSelections;
          _this10.actions.decisionOptionServiceIdsForRemovalSelected(decision.decisionId, decision.optionId, undefined);
          _this10.actions.decisionOptionQuantityChanged(originalQuantity, decision.decisionId, decision.optionId, false);
        });
        if (!this.state.decisionsHasValidationError) {
          this.actions.setCurrentStepIsInvalid(false);
        }
      }
      this.intendedDecisionsPage = null;
      this.intendedDecisionsPageWhenDecisionAffectedServicesResolved = null;
      this.showSelectAffectedServicesPopup = false;
    }
  }, {
    key: "applyDecisionAffectedServicesResolutionsCallback",
    value: function applyDecisionAffectedServicesResolutionsCallback() {
      if (!this.state.decisionsHasValidationError) {
        this.actions.setCurrentStepIsInvalid(false);
      }
      this.showSelectAffectedServicesPopup = false;
      if (this.intendedDecisionsPage) {
        this.intendedDecisionsPageWhenDecisionAffectedServicesResolved = this.intendedDecisionsPage;
        this.intendedDecisionsPage = null;
      } else if (this.proceedToAttributesStepWhenDecisionAffectedServicesResolved) {
        this.proceedToAttributesStepWhenDecisionAffectedServicesResolved = false;
        this.attemptNextStep();
      }
    }
  }, {
    key: "deregisterUnsavedChanges",
    value: function deregisterUnsavedChanges() {
      this.actions.unregisterUnsavedChanges('editOfferWizard');
      this.actions.resetMobileNumberPortabilityModels();
    }
  }, {
    key: "goToPreviousStep",
    value: function goToPreviousStep() {
      if (this.state.isCheckoutStep) {
        this.actions.setPaymentInfo(this.state.paymentInfoEdit);
      }
      if (this.state.isAttributesStep && this.isAttributesFormInvalid()) {
        this.wizardForm.$setSubmitted();
        this.actions.setAttributeFormSubmitted(true);
        return;
      }
      this.actions.goToPreviousStep();
      if (this.state.isDecisionsStep) {
        this.actions.setAttributeFormSubmitted(false);
        this.actions.setActiveAttributeFormName(null);
      }
    }
  }, {
    key: "isAttributesFormInvalid",
    value: function isAttributesFormInvalid() {
      return this.wizardForm['attributesController.attributesForm'] && this.wizardForm['attributesController.attributesForm'].$invalid || !this.state.allAttributesAreValid;
    }
  }, {
    key: "isCheckoutFormInvalid",
    value: function isCheckoutFormInvalid() {
      return this.wizardForm['$ctrl.paymentInstrumentForm'] && this.wizardForm['$ctrl.paymentInstrumentForm'].$invalid;
    }
  }, {
    key: "onSubmit",
    value: function onSubmit() {
      if (!this.state.isSubmittingOrder) {
        this.$element.find('button[type="submit"]')[0].focus();
        this.$timeout(this.attemptNextStep);
      }
    }
  }, {
    key: "handleInventoryAvailabilityContinue",
    value: function handleInventoryAvailabilityContinue(isSendToStore) {
      var _this11 = this;
      return this.actions.fetchAttributesQuote(this.state.customerId, this.state.editOfferingId, this.state.editOfferingInstanceId, this.getCompletedDecisions(), this.state.formattedAttributes, this.state.formattedPhysicalAttributes, this.state.isConvergentBiller, this.isReconnectOffer).then(function () {
        _this11.actions.calculateChangeOfServiceOfferingOrderQuote(_this11.state.customerInfo, _this11.state.editOfferingId, _this11.state.addItems, _this11.state.removeItems, _this11.state.modifyItems, _this11.state.executionOptions, _this11.isReconnectOffer, undefined, _this11.state.selectedDeliveryDecision === DELIVERY_OPTIONS.SHIPPED, _this11.overrideBypassQuoteConfiguration).then(function () {
          if (_this11.state.offeringOrderAsyncId) {
            _this11.repeatRetrieveQuote();
          }
        });
      }).then(function () {
        if (isSendToStore) {
          _this11.openSendToStorePopup();
        } else {
          if (_this11.state.offeringOrderAsyncId) {
            _this11.repeatRetrieveQuote();
          }
          _this11.actions.goToNextStep();
        }
      }).then(function () {
        _this11.wizardForm.$setPristine();
      }).catch(function (error) {
        _this11.uiNotificationService.transientError(error.translatedMessage);
      });
    }
  }, {
    key: "getCompletedDecisions",
    value: function getCompletedDecisions() {
      return [].concat(_toConsumableArray(this.state.serviceTaxDecisions), _toConsumableArray(this.state.formattedDeliveryDecisions), _toConsumableArray(this.state.completedDecisions));
    }
  }, {
    key: "attemptNextStep",
    value: function attemptNextStep() {
      var _this12 = this;
      var isSendToStore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var dirty = true;
      // NOTE: this may register non-existant (extraneous) "unsaved
      // changes" in the case that the user tries to proceed to the next
      // step, but has not dirtied the form
      this.actions.registerUnsavedChanges('editOfferWizard', {
        isDirty: function isDirty() {
          return dirty;
        },
        setPristine: function setPristine() {
          dirty = false;
        }
      });
      if (this.state.decisionsRequireAffectedServicesResolution) {
        if (this.state.isDecisionsStep) {
          this.proceedToAttributesStepWhenDecisionAffectedServicesResolved = true;
        }
        this.beginResolveDecisionAffectedServicesCallback();
      } else if (this.state.isAttributesStep && !this.state.hasRequiredAndUnavailableInventory) {
        this.actions.setAttributeFormSubmitted(true);
        if (!this.isAttributesFormInvalid() && !duplicatedServiceIdentifierAttributes(this.state.formAttributeGroups).length) {
          if (this.state.formattedPhysicalAttributes.length) {
            var transitionOutcomes = null;
            this.actions.resetAvailableInventoryInformation();
            this.actions.fetchAttributes({
              completedAttributes: this.state.formattedAttributes,
              completedDecisions: this.getCompletedDecisions(),
              completedPhysicalAttributes: this.state.formattedPhysicalAttributes,
              isConvergentBiller: this.state.isConvergentBiller,
              isEditOffer: true,
              isReconnectAction: this.isReconnectOffer,
              offeringId: this.state.selectedOfferId,
              offeringInstanceId: this.state.editOfferingInstanceId,
              transitionOutcomes: transitionOutcomes
            }).then(function () {
              if (_this12.isReconnectOffer) {
                _this12.handleInventoryAvailabilityContinue();
              } else {
                if (_this12.state.selectedDeliveryDecision === DELIVERY_OPTIONS.SHIPPED) {
                  _this12.actions.setInventoryRegionFilter(_this12.state.dbssShippingEnabledRegionId);
                }
                if (_this12.state.selectedInventoryStores.length < 1) {
                  if (isSendToStore || _this12.state.isSubscriberProductIdUndefined) {
                    _this12.openStoreSearch(isSendToStore);
                  } else {
                    _this12.handleInventoryAvailabilityContinue();
                  }
                } else if (isSendToStore || _this12.state.selectedDeliveryDecision === DELIVERY_OPTIONS.SHIPPED) {
                  _this12.actions.searchInventoriesAvailability(_this12.state.formattedPhysicalInventories).then(function () {
                    if (!_this12.state.isAllSelectedPhysicalInventoryAvailable) {
                      if (_this12.state.selectedDeliveryDecision === DELIVERY_OPTIONS.SHIPPED) {
                        _this12.uiNotificationService.transientError(i18n.translate(CustomerCareKeys.ATTRIBUTES.UNAVAILABLE_SHIPPING_INVENTORY));
                      } else if (isSendToStore) {
                        _this12.openStoreSearch();
                      }
                    } else if (isSendToStore) {
                      _this12.openSendToStorePopup();
                    } else {
                      _this12.handleInventoryAvailabilityContinue();
                    }
                  }).catch(function (err) {
                    if (isSendToStore) {
                      _this12.showStoreInventoryPopup = true;
                      _this12.$timeout(function () {
                        _this12.storeSearchInventoryApi.open();
                      });
                    }
                    _this12.onSearchInventoryAvailabilityFailure(err);
                  });
                } else {
                  _this12.handleInventoryAvailabilityContinue();
                }
              }
            });
          } else if (isSendToStore) {
            this.openSendToStorePopup();
          } else {
            this.handleInventoryAvailabilityContinue();
          }
        }
      } else if (this.state.isCheckoutStep) {
        if (isSendToStore) {
          if (this.state.selectedInventoryStores.length < 1) {
            this.openStoreSearch();
          } else {
            this.actions.searchInventoriesAvailability(this.state.formattedPhysicalInventories).then(function () {
              if (!_this12.state.isAllSelectedPhysicalInventoryAvailable) {
                _this12.openStoreSearch();
              } else if (isSendToStore) {
                _this12.openSendToStorePopup();
              }
            });
          }
        } else if (!this.isCheckoutFormInvalid()) {
          this.validateAddressWithAPI().then(function () {
            var addressKey = _this12.getAddressKey(),
              validatedAddress = _this12.state.validatedAddresses[addressKey];
            if (!addressKey || validatedAddress && isAddressValidFromAddressResponse(validatedAddress)) {
              var paymentInfo;
              // if statement handled this way to make sure it has an Id, otherwise it returns a function if null
              if (pathOr(false, ['Id'], _this12.state.selectedPayment)) {
                paymentInfo = _this12.state.supplyPaymentInstrument || _this12.state.paymentInstrumentRequired ? _this12.state.selectedPaymentClean : null;
              } else {
                _this12.actions.setPaymentInfo(_this12.state.paymentInfoEdit);
                paymentInfo = _this12.state.paymentInfoEdit;
                if (_this12.state.paymentInfoEdit && _this12.state.paymentInfoEdit.BillingAddressIsServiceAddress) {
                  paymentInfo = Object.assign({}, paymentInfo, {
                    BillingAddressId: _this12.state.serviceAddress.Id
                  });
                }
                if (_this12.state.paymentInfoEdit && !_this12.state.paymentInfoEdit.BillingAddressIsServiceAddress) {
                  var billingAddress = Object.assign({}, paymentInfo.BillingAddress, {
                    Name: _this12.state.paymentInfoEdit.BillingAddress.LineOne // Name is required by the API and needs to be unique.
                  });
                  paymentInfo = Object.assign({}, paymentInfo, {
                    BillingAddress: billingAddress
                  });
                }
              }
              _this12.actions.setCustomerAutoPayBannerFlag(_this12.state.selectedPaymentMethodAutoPay);
              if (_this12.state.currentCustomerCreditLimit && !_this12.isReconnectOffer) {
                _this12.checkCreditandFinanceLimitAndSubmitOrder(paymentInfo);
              } else {
                _this12.editOfferSubmitCOSOrder(paymentInfo);
              }
            } else {
              _this12.actions.setForceShowEditFormAddress(false);
              _this12.uiNotificationService.transientError(i18n.translate(_this12.customerCareKeys.ADDRESS_COMPONENT.INVALID_ADDRESS_ERROR_MESSAGE));
            }
          }).catch(function (err) {
            _this12.uiNotificationService.transientError(err.translatedMessage);
          });
        }
      } else if (this.state.isDecisionsStep && !this.state.decisionsHasValidationError) {
        /*
            For the resumeStoreOrder scenario in edit or change offer, when we hit
            the `sendToStore` API unlike `addOffer` we do not send along a saved shopping cart.
            Therefore we do not need to update the shopping cart like in add since we do not get back
            a shopping cart from the API.
        */
        if (this.state.isResumingStoreOrder) {
          if (this.state.formattedPhysicalAttributes.length === 0) {
            //We are setting this to populate the decition type 4 selectors
            this.actions.setEditPhysicalAttributeGroups({
              physicalAttributeGroups: this.state.physicalAttributeGroups,
              formPhysicalAttributeGroups: this.state.formPhysicalAttributeGroups
            });
          }
          if (!this.state.filteredFormAttributeGroups || this.state.filteredFormAttributeGroups.length === 0) {
            this.actions.setEditAttributeGroups(this.state.attributeGroups);
          }
        }
        this.actions.fetchPreviousAttributesAndNavigate(this.state.customerInfo, this.state.editOfferingId, this.state.editOfferingInstanceId, this.state.isResumingStoreOrder ? [].concat(_toConsumableArray(this.getCompletedDecisions()), _toConsumableArray(this.state.formattedAttributes), _toConsumableArray(this.state.formattedPhysicalAttributes)) : [].concat(_toConsumableArray(this.getCompletedDecisions()), _toConsumableArray(this.state.formattedAttributes)), this.state.isConvergentBiller, this.isReconnectOffer, this.overrideBypassQuoteConfiguration).then(function () {
          if (_this12.state.isResumingStoreOrder) {
            _this12.actions.setIsResumingStoreOrderForEditOffer(false);
          }
          _this12.wizardForm.$setPristine();
        });
      } else if (!this.state.currentStepIsInvalid) {
        this.redirectToCustomer();
      } else {
        this.$log.warn('The current step has errors');
      }
    }
  }, {
    key: "checkCreditandFinanceLimitAndSubmitOrder",
    value: function checkCreditandFinanceLimitAndSubmitOrder(paymentInfo) {
      var isFinanceCreditLimitBreached = this.validateFinanceCreditLimitFromQuote();
      if (!this.state.isCreditLimitBreached && !isFinanceCreditLimitBreached) {
        this.editOfferSubmitCOSOrder(paymentInfo);
      }
    }
  }, {
    key: "validateFinanceCreditLimitFromQuote",
    value: function validateFinanceCreditLimitFromQuote() {
      return this.state.availableFinanceCreditFromQuote > 0;
    }
  }, {
    key: "editOfferSubmitCOSOrder",
    value: function editOfferSubmitCOSOrder(paymentInfo) {
      var _this13 = this;
      this.actions.editOfferSubmitCosOrder(this.state.customerId, this.state.editOfferingId, this.state.editOfferingInstanceId, this.state.addItems, this.state.modifyItems, this.state.removeItems, paymentInfo, this.state.changesEffective, this.state.executionOptions, this.state.recordPaymentInfo, this.isReconnectOffer, pathOr(null, ['selectedOfferingPickupId', 'Id'], this.state), this.state.orderAdditionalProperties, this.state.selectedShippingAddressAndMethod, this.state.orderDetails).then(function () {
        //Below might not be necessary
        if (_this13.state.isResumingOrder) {
          _this13.actions.setIsResumingStoreOrderForEditOffer(false);
        }
        _this13.orderConfirmationPopup.open();
        _this13.actions.resetMobileNumberPortabilityModels();
      }).catch(function (error) {
        _this13.submitCoSError = error.translatedMessage;
        _this13.submitOrderErrorPopupApi.open();
      });
    }
  }, {
    key: "recalculateOrderQuote",
    value: function recalculateOrderQuote() {
      var _this14 = this;
      this.actions.calculateChangeOfServiceOfferingOrderQuote(this.state.customerInfo, this.state.editOfferingId, this.state.shoppingCart.AddItems, this.state.shoppingCart.RemoveItems, this.state.shoppingCart.ModifyItems, this.state.executionOptions, this.isReconnectOffer, this.state.selectedShippingAddressAndMethod, !!this.state.shippingAddress, this.overrideBypassQuoteConfiguration).then(function () {
        if (_this14.state.offeringOrderAsyncId) {
          _this14.repeatRetrieveQuote();
        }
      }).catch(function (error) {
        _this14.uiNotificationService.transientError(error.translatedMessage);
      });
    }
  }, {
    key: "redirectToCustomer",
    value: function redirectToCustomer() {
      this.deregisterUnsavedChanges();
      this.$state.go(CUSTOMER_URL, {
        'customerId': this.state.customerInfo.Id,
        'showAutoPayBanner': {
          enabled: this.state.showCustomerAutoPayBanner,
          customerId: this.state.customerInfo.Id
        }
      }, {
        reload: true
      });
    }
  }, {
    key: "tabSelected",
    value: function tabSelected(selectedTab) {
      var selectedIndex = findIndex(function (tab) {
        return tab === selectedTab;
      })(this.state.tabs);
      this.actions.setSelectedTab(selectedIndex);
    }
  }, {
    key: "updateCart",
    value: function updateCart(offerId, offeringInstanceId, completedDecisions, isModify, customerId, callback, contextOfferingAction, transitionContext, isConvergentBiller, customerLanguage) {
      this.actions.setDevicePaymentOptions([]);
      this.actions.updateCart(offerId, offeringInstanceId, completedDecisions, isModify, customerId, callback, this.isReconnectOffer ? ContextOfferingAction.RECONNECT : contextOfferingAction, transitionContext, isConvergentBiller, customerLanguage);
    }
  }, {
    key: "cancelClick",
    value: function cancelClick() {
      if (this.unsavedChangesPrompt.hasUnsavedChanges()) {
        this.unsavedChangesPromptPopupApi.open();
      } else {
        this.handleCancel();
      }
    }
  }, {
    key: "handlePreviewRenewalStatements",
    value: function handlePreviewRenewalStatements() {
      this._openPreviewRenewalStatementsPopup();
    }
  }, {
    key: "handleClosePreviewRenewalStatementsDialog",
    value: function handleClosePreviewRenewalStatementsDialog() {
      this._closePreviewRenewalStatementsPopup();
    }
  }, {
    key: "_openPreviewRenewalStatementsPopup",
    value: function _openPreviewRenewalStatementsPopup() {
      this.showPreviewRenewalStatementsDialog = true;
      this.$timeout(this._previewRenewalStatementsPopupApi.open);
    }
  }, {
    key: "_closePreviewRenewalStatementsPopup",
    value: function _closePreviewRenewalStatementsPopup() {
      this.showPreviewRenewalStatementsDialog = false;
      this._previewRenewalStatementsPopupApi.close();
    }
  }, {
    key: "onSelectInventoryStore",
    value: function onSelectInventoryStore() {
      var _this15 = this;
      this.showSelectStorePopup = true;
      if (this.state.selectedInventoryRegion) {
        this.actions.setInventoryRegionFilter(this.state.selectedInventoryRegion);
      }
      this.$timeout(function () {
        _this15.selectStorePopupApi.open();
      });
    }
  }, {
    key: "closeSelectStorePopupDialog",
    value: function closeSelectStorePopupDialog(applyChanges, selectedStore) {
      this.showSelectStorePopup = false;
      if (applyChanges) {
        this.actions.setSelectedInventoryStores([selectedStore]);
      }
      this.actions.setInventoryRegionFilter(null);
      this.selectStorePopupApi.close();
    }
  }, {
    key: "onInventoryRegionFilterChanged",
    value: function onInventoryRegionFilterChanged(region) {
      this.actions.setInventoryRegionFilter(region);
    }
  }, {
    key: "onInventoryRegionFilterChangedForStoreSearch",
    value: function onInventoryRegionFilterChangedForStoreSearch(region) {
      this.actions.setInventoryRegionFilter(region);
      this.actions.resetAvailableInventoryInformation();
      var formattedInventories = this.state.physicalInventories,
        formattedPayload = !this.state.formattedInventories ? {
          InventoryTypes: formattedInventories,
          RegionId: region
        } : this.state.formattedPhysicalInventories;
      this.actions.searchInventoriesAvailability(formattedPayload).catch(this.onSearchInventoryAvailabilityFailure);
    }
  }, {
    key: "closeSearchInventoryPopupDialog",
    value: function closeSearchInventoryPopupDialog() {
      this.showStoreInventoryPopup = false;
      this.actions.setInventoryRegionFilter(null);
      this.storeSearchInventoryApi.close();
    }
  }, {
    key: "setSelectedStoreForSearchModal",
    value: function setSelectedStoreForSearchModal(selectedStore) {
      this.actions.setSelectedInventoryStores([selectedStore]);
      this.showStoreInventoryPopup = false;
      this.storeSearchInventoryApi.close(); //need to fix this?
      this.handleInventoryAvailabilityContinue(this.isSubmitForPickUp || !this.state.isSubscriberProductIdUndefined);
    }
  }, {
    key: "openStoreSearch",
    value: function openStoreSearch() {
      var _this16 = this;
      var isSendToStore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.isSubmitForPickUp = isSendToStore;
      this.showStoreInventoryPopup = true;
      this.$timeout(function () {
        _this16.storeSearchInventoryApi.open();
      });
    }
  }, {
    key: "openSendToStorePopup",
    value: function openSendToStorePopup() {
      var _this17 = this;
      this.isLoading = false;
      this.sendToStorePickupDetailsConfig = {
        maxDate: undefined,
        minDate: Date.now()
      };
      this.showSendToStorePopup = true;
      this.$timeout(function () {
        _this17.sendToStorePopupApi.open();
      });
    }
  }, {
    key: "closeSendToStorePopup",
    value: function closeSendToStorePopup() {
      this.showSendToStorePopup = false;
      this.sendToStorePopupApi.close();
    }
  }, {
    key: "sendToStore",
    value: function sendToStore() {
      this.handleSendToStore();
    }
  }, {
    key: "handleSendToStore",
    value: function handleSendToStore() {
      var _this18 = this;
      var offeringId = this.state.editOfferingId,
        offeringInstanceId = this.state.editOfferingInstanceId;
      var offering = {
        Action: this.isReconnectOffer ? ContextOfferingAction.RECONNECT : ContextOfferingAction.MODIFY,
        OfferingId: offeringId,
        OfferingInstanceId: offeringInstanceId
      };
      this.actions.sendInventoryToStore(this.state.customerInfo.Id, this.state.cartAdditionalProperties.length ? {
        AdditionalProperties: this.state.cartAdditionalProperties
      } : undefined, this.state.inventoryStorePickupDetails, offering, this.getCompletedDecisions().concat(this.state.formattedAttributes).concat(this.state.formattedPhysicalAttributes)).then(function () {
        _this18.actions.setIsResumingStoreOrderForEditOffer(false);
        _this18.actions.unregisterUnsavedChanges('$ctrl.sendToStoreForm');
        _this18.closeSendToStorePopup();
        _this18.onOrderActionSuccess(CustomerCareKeys.SEND_TO_STORE.SEND_SUCCESS);
      }).catch(function (error) {
        if (error.Code === INVENTORY_ITEM_RESERVATION_FAULT_CODE) {
          _this18.closeSendToStorePopup();
          _this18.isInventoryItemReservationFault = true;
          _this18.openStoreSearch();
        } else if (error.Code === EXISTING_SAVED_CART_FOR_SEND_TO_STORE_FAULT_CODE) {
          _this18.closeSendToStorePopup();
          _this18.submitForPickupErrorPopupApi.open();
        } else {
          _this18.uiNotificationService.transientError(error.translatedMessage);
        }
      });
    }
  }, {
    key: "onUpdateSelectedServiceFeatures",
    value: function onUpdateSelectedServiceFeatures(attributeId, selectedServiceFeatures, billerRuleInstanceDetails) {
      var _this19 = this;
      var removedItems = clone(this.state.removeItems);
      if (!this.initialServiceFeatures[attributeId]) {
        this.state.formAttributeGroups.forEach(function (attributeGroup) {
          return attributeGroup.attributes.find(function (attribute) {
            if (attribute.id === attributeId) {
              return _this19.initialServiceFeatures[attributeId] = attribute.serviceFeatures;
            }
          });
        });
      }
      selectedServiceFeatures.forEach(function (serviceFeature) {
        if (!serviceFeature.SubscriberProductId) {
          if (_this19.initialServiceFeatures[attributeId] && _this19.initialServiceFeatures[attributeId].find(function (initialServiceFeature) {
            return initialServiceFeature.ProductId === serviceFeature.ProductId && initialServiceFeature.PricingPlanId === serviceFeature.PricingPlanId;
          })) {
            var restorableIndex = removedItems.findIndex(function (item) {
              return item.ProductId === serviceFeature.ProductId && item.PricingPlanId === serviceFeature.PricingPlanId;
            });
            if (restorableIndex > -1) {
              serviceFeature.SubscriberProductId = removedItems[restorableIndex].LockerItemId;
            }
          }
        }
      });
      this.actions.updateSelectedServiceFeatures(attributeId, selectedServiceFeatures, billerRuleInstanceDetails);
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.cancelResolveDecisionAffectedServicesCallback();
      this.disconnectRedux();
    }
  }, {
    key: "getAddressKey",
    value: function getAddressKey() {
      return pathOr(undefined, ['wizardForm', '$ctrl.paymentInstrumentForm', 'addressWrapupController.singleAddressFormFormApi', 'addressKey'], this);
    }
  }, {
    key: "getAddressKeyForAddressValidatedThroughAPI",
    value: function getAddressKeyForAddressValidatedThroughAPI() {
      return pathOr(undefined, ['wizardForm', '$ctrl.paymentInstrumentForm', 'addressWrapupController.singleAddressFormFormApi', 'keyForAddressValidatedThroughAPI'], this);
    }
  }, {
    key: "getJobToken",
    value: function getJobToken() {
      var addressKey = this.getAddressKey(),
        addressKeyForAddressValidatedThroughAPI = this.getAddressKeyForAddressValidatedThroughAPI(),
        validatedAddressForCurrentAddress = this.state.validatedAddresses[addressKey],
        validatedAddressForAddressValidatedThroughAPI = this.state.validatedAddresses[addressKeyForAddressValidatedThroughAPI];
      if (validatedAddressForCurrentAddress && validatedAddressForCurrentAddress.JobToken) {
        return validatedAddressForCurrentAddress.JobToken;
      } else if (validatedAddressForAddressValidatedThroughAPI && validatedAddressForAddressValidatedThroughAPI.JobToken) {
        return validatedAddressForAddressValidatedThroughAPI.JobToken;
      }
      return null;
    }
  }, {
    key: "validateAddressWithAPI",
    value: function validateAddressWithAPI() {
      /*
          This will only get called if the payment instrument component appears which should
          only occure if they have no defaultBilling Payment method
      */
      var addressKey = this.getAddressKey(),
        unvalidatedAddress = this.state.unvalidatedAddresses[addressKey],
        validatedAddress = this.state.validatedAddresses[addressKey],
        addressTypes = {
          DefaultBilling: true
        };
      if (validatedAddress || !unvalidatedAddress) {
        return Promise.resolve(100);
      } else {
        return this.actions.validateAddress(addressKey, unvalidatedAddress, this.getJobToken(), addressTypes);
      }
    }
  }, {
    key: "searchAvailableOfferings",
    value: function searchAvailableOfferings() {
      var data = {
        OfferingIds: [this.state.selectedOfferId]
      };
      return this.actions.searchAvailableOfferings(data, {
        pageNumber: 1
      }, undefined, this.state.customerInfo.Id);
    }
  }, {
    key: "onOrderActionSuccess",
    value: function onOrderActionSuccess(messageKey) {
      this.uiNotificationService.transientSuccess(i18n.translate(messageKey));
      this.redirectToCustomer();
    }
  }, {
    key: "onMoreActionSelected",
    value: function onMoreActionSelected(action) {
      if (action === MINI_CART_MORE_ACTIONS.EDIT_SINGLE_OFFER) {
        this.actions.goToStep(CustomerCareKeys.WIZARD.STEPS.DECISIONS);
      }
    }
  }]);
}(OfferWizard);
export default {
  template: require('./edit.offer.wizard.html'),
  controller: EditOfferWizardController,
  controllerAs: 'editOfferController'
};